// extracted by css-extract-rspack-plugin
export default {"container":"COyKR","center":"tqAWv","img":"Hx8EK","texts":"r9V2c","buttons":"VTmC9","button_override":"sZUUm","buttonOverride":"sZUUm","#":"XsW0O"};